import { isTottusStandalone } from '@digital-retail/store-manager';

export const getQuantityUnit = ({ store }) => {
  let quantityUnit = 'C/U';
  if (isTottusStandalone(store)) {
    quantityUnit = 'UNITS';
  }
  return quantityUnit;
};
